import React from 'react';
import styles from './SDGBadge.module.css';
import { getSDGByNumber } from '../../constants/sdg';

interface SDGBadgeProps {
  sdgNumber: number;
  size?: 'small' | 'medium' | 'large';
  showTitle?: boolean;
  className?: string;
  onClick?: (sdgNumber: number) => void;
}

/**
 * SDGBadge - Display a single SDG with its official color and icon
 * Designed for use in bond cards and lists to show SDG alignment
 */
const SDGBadge: React.FC<SDGBadgeProps> = ({
  sdgNumber,
  size = 'medium',
  showTitle = false,
  className = '',
  onClick
}) => {
  const sdg = getSDGByNumber(sdgNumber);

  if (!sdg) {
    return null;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onClick) {
      onClick(sdgNumber);
    }
  };

  const badgeContent = (
    <>
      <span className={styles.number}>{sdg.number}</span>
      {showTitle && (
        <span className={styles.title}>{sdg.title}</span>
      )}
    </>
  );

  const combinedClassName = `${styles.badge} ${styles[size]} ${className}`;

  return onClick ? (
    <button
      type="button"
      className={combinedClassName}
      style={{ backgroundColor: sdg.color }}
      onClick={handleClick}
      title={`SDG ${sdg.number}: ${sdg.title}`}
      aria-label={`SDG ${sdg.number}: ${sdg.title}`}
    >
      {badgeContent}
    </button>
  ) : (
    <div
      className={combinedClassName}
      style={{ backgroundColor: sdg.color }}
      title={`SDG ${sdg.number}: ${sdg.title}`}
      aria-label={`SDG ${sdg.number}: ${sdg.title}`}
    >
      {badgeContent}
    </div>
  );
};

export default SDGBadge;